import styles from './WhatAreYouWaitingOn.module.scss';
export const WhatAreYouWaitingOn = () => {
  return (
    <div className={styles.container}>
      <h3>Hey, what are you waiting on?</h3>
      <button>Join Now</button>
    </div>
  );
};
